import { render, staticRenderFns } from "./ControlPlaceholder.vue?vue&type=template&id=0547b5bb&scoped=true&"
import script from "./ControlPlaceholder.vue?vue&type=script&lang=js&"
export * from "./ControlPlaceholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0547b5bb",
  null
  
)

export default component.exports